import emitter from '@/scripts/stage/globals/emitter';

class Mediator {
  constructor() {
    this.emitter = emitter;
    this.now = Date.now();
    this.w = 0;
    this.h = 0;
    this.isPlaying = false;
  }

  update() {
    if (this.isPlaying === false) {
      this.now = Date.now();
    }

    const tempnow = Date.now();

    const delta = (tempnow - this.now) / 1000;

    this.now = tempnow;

    this.absTimer += delta;

    this.emitter.emit('update', delta);

    this.emitter.emit('postupdate', delta);

    if (this.isPlaying) {
      this.raf = requestAnimationFrame(this.update.bind(this));
    }
  }

  pause() {
    if (this.raf) {
      cancelAnimationFrame(this.raf);

      this.raf = null;
    }

    this.isPlaying = false;
  }

  play() {
    this.isPlaying = true;

    this.now = Date.now();

    this.update();
  }

  // browser
  resize(w = null, h = null) {
    this.w = w == null ? window.innerWidth : w;

    this.h = h == null ? window.innerHeight : h;

    this.emitter.emit('resize', this.w, this.h);

    if (this.isPlaying === false) {
      this.update();
    }
  }
}

export default new Mediator();
